module.exports = __webpack_public_path__ + "/d2e53334c22a9a4937bc26e84b36e1e0.svg";